"use client";
import React, { useState } from "react";

const faqs = [
  {
    question: "كيف يمكنني التسجيل في المنصة؟",
    answer:
      "يمكنك التسجيل بسهولة من خلال الضغط على زر 'أنشئ حسابك الآن' واتباع الخطوات المطلوبة.",
  },
  {
    question: "هل الكورسات متاحة لجميع المراحل الدراسية؟",
    answer: "نعم، المنصة توفر كورسات وكتب وامتحانات لجميع المراحل الدراسية.",
  },
  {
    question: "كيف يمكنني التواصل مع المدرسين؟",
    answer:
      "يمكنك التواصل مع المدرسين من خلال صفحة الكورس أو من خلال الرسائل داخل المنصة.",
  },
  {
    question: "هل يوجد دعم فني؟",
    answer:
      "نعم، يوجد دعم فني متاح على مدار الساعة لمساعدتك في أي مشكلة تواجهك.",
  },
];

const FrequentlyQuestions = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="mb-10 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-white">
          الأسئلة الشائعة
        </h2>
        <p className="text-lg md:text-xl text-[#C7D0E0] max-w-2xl mx-auto">
          إجابات على أكثر الأسئلة شيوعًا حول المنصة والخدمات.
        </p>
      </div>
      <div className="space-y-4">
        {faqs.map((faq, idx) => (
          <div key={idx} className="bg-[#232c37] rounded-2xl p-6 shadow-md">
            <button
              className="w-full flex justify-between items-center text-lg font-bold text-white focus:outline-none"
              onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              aria-expanded={openIndex === idx}
              aria-controls={`faq-answer-${idx}`}
            >
              <span>{faq.question}</span>
              <span className="text-primaryColor text-2xl">
                {openIndex === idx ? "-" : "+"}
              </span>
            </button>
            {openIndex === idx && (
              <div
                id={`faq-answer-${idx}`}
                className="mt-4 text-[#C7D0E0] text-base text-right animate-fadeIn"
              >
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FrequentlyQuestions;
